import { Stack, StackOwnProps, styled } from '@mui/material';
import { LayoutAlignItems, LayoutDirection, LayoutJustifyContent } from '@/constants/layoutTypes';

interface LayoutProps {
  id?: string | null;
  direction: LayoutDirection;
  spacing: number;
  align_items: LayoutAlignItems;
  justify_content: LayoutJustifyContent;
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ id, direction, spacing, align_items, justify_content, children }) => {
  return (
    <StyledStack
      id={id ?? undefined}
      direction={direction}
      spacing={spacing}
      alignItems={align_items}
      justifyContent={justify_content}
    >
      {children}
    </StyledStack>
  );
};

interface StyledLayoutProps {
  direction: StackOwnProps['direction'];
  spacing: StackOwnProps['spacing'];
  alignItems: LayoutAlignItems;
  justifyContent: LayoutJustifyContent;
}

const StyledStack = styled(Stack)<StyledLayoutProps>`
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  text-wrap: pretty;
`;
